import { getDateString } from './helper';
import * as S from './style';

export interface TooltipEmployeeProps {
  date: string;
  xAlign: 'left' | 'center' | 'right';
  $x: number;
  $y: number;
  $opacity: number;
  total?: number;
  hired?: number;
  left?: number;
}

export default function TooltipEmployee({
  date,
  total,
  hired,
  left,
  xAlign,
  $x,
  $y,
  $opacity,
}: TooltipEmployeeProps) {
  return (
    <S.Wrapper $x={$x} $y={$y} xAlign={xAlign} $opacity={$opacity}>
      <S.Date>{getDateString(date)}</S.Date>
      <S.Total>전체: {total}명</S.Total>
      <S.HiredAndLeft>
        입사 {hired}명 / 퇴사: {left}명
      </S.HiredAndLeft>
    </S.Wrapper>
  );
}
